import React from 'react';
import BaseLayout from '../../common/layouts/BaseLayout';
import styles from '../../common/utils/styles/css/styles';
import styled, { css } from 'styled-components';
import Button from '../../common/components/basic/Button';
import { Container, MaxWidth, MinWidth } from '../../common/base';
import Responsive from '../../common/components/basic/Responsive';
import { Element, scroller } from 'react-scroll';
import Values from '../components/Values';
import Culture from '../components/Culture';
import Benefits from '../components/Benefits';
import Jobs from '../components/Jobs';
import Desktop from '../../common/utils/styles/css/MediaQuery/Desktop';
import HeadShared from '../../common/HeadShared';

const ImageContainer = styled.div`
  top: 0;
  right: 0px;
  width: 100%;
  height: 44vh;
  z-index: 20;
  position: absolute;
  ${MaxWidth.md`
    width: 80%;
  `}
  ${MaxWidth.sm`
    position: relative;
    top: 0;
    width: 100%;
  `}
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
  opacity: 1;
  transition: opacity 500ms ease 0s;
`;

export default function CareerPage() {
  return (
    <BaseLayout headerType="red">
      <div css={styles.bglp}>
        <HeadShared title="RupiahToken - Career" />
        <div>
          <Desktop>
            <div
              css={[
                styles.bgpl,
                css`
                  height: 20vh;
                `
              ]}
            >
              <Image width={600} src="/static/images/illustrations/hero-landing.svg" />
            </div>
          </Desktop>
        </div>
        <div
          css={[
            styles.flex,
            css`
              ${MaxWidth.sm`flex-direction: column;`}
            `
          ]}
        >
          <div
            css={[
              styles.flex1,
              css`
                ${MinWidth.sm`
                ${styles.bggl}
              `}
              `
            ]}
          >
            <h1
              css={css`
                margin: 30px 15px;
                ${MaxWidth.sm`
                margin: 30px 26px;
                margin-bottom: 0px;
              `}
                ${MinWidth.sm`
                position: absolute;
                bottom: 0px;
                right: 5%;
              `}
              font-size: 18vmin;
                line-height: 0.725;
              `}
            >
              Hello
            </h1>
          </div>
          <div css={[styles.flex1, styles.flexLeftRight, styles.pam, styles.flexDirCol]}>
            <div css={[styles.flex, styles.mal, styles.flexDirCol]}>
              <h4 css={styles.h3}>
                "Our Mission is to accelerate the transition to an open financial system"
              </h4>
              <div css={[styles.h3, styles.ptm, styles.fcm]}>We saved a seat for you</div>
            </div>
            <div css={styles.mhm}>
              <Button
                onClick={() =>
                  scroller.scrollTo('jobs', {
                    duration: 500,
                    offset: -50,
                    smooth: true
                  })
                }
              >
                View All Position
              </Button>
            </div>
          </div>
        </div>
        <Culture />
        <Values />
        <Benefits />
        <Element name="jobs">
          <Jobs />
        </Element>
        <div
          css={css`
            height: 50px;
          `}
        />
      </div>
    </BaseLayout>
  );
}
